/**
  * 人客合一模块接口列表
*/
import axios from './http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const guestUnity = {
  // 销售报表
  getSaledtf(params){
    // return axios.post('http://10.12.30.155:8071/saledtf/list',params);
    return axios({
      method: 'post',
      url: '/analysisfors-visitors/saledtf/list',
      data: params,
      timeout: 1000 * 60 * 2,
    });
  },
  // 销售报表-月度
  getSaleyearmhf(params){
    // return axios.post('http://10.12.30.155:8071/saleyearmhf/list',params);
    
    return axios({
      method: 'post',
      url: '/analysisfors-visitors/saleyearmhf/list',
      data: params,
      timeout: 1000 * 60 * 2,
    });
  },
};

export default guestUnity;


// WEBPACK FOOTER //
// ./src/api/api_guestUnity.js